module.exports = __webpack_public_path__ + "media/customizations/hylandtrail/logo-new-f83244af1656f64ce112274ad9e372b2.png";